import React from 'react';
import {counterAction} from "../../../../store/actions/sidebarActions";
import {connect} from "react-redux";
import * as consts from "../../../../store/constants/sidebar";


class CounterTaxes extends React.Component {

  componentDidMount() {
    if (this.props.taxes.items) return;
    this.props.fetchData(process.env.REACT_APP_GATE + "payment/document", consts.PAYMENT_DOCUMENT);
  }

  render() {
    if(this.props.taxes.items) {
      if (this.props.taxes.items?.data?.length) {
        let taxesAmount = document.createElement('div');
        taxesAmount.setAttribute('id', 'taxes-list');
        let documents = this.props.taxes.items?.data[0]?.paymentDocuments;
        let surnames = documents.map(x => x.amount);
        let result = surnames.map(function (x) {
          return parseFloat(x, 10);
        });
        let setResult = result.reduce((a, b) => a + b, 0);
        let decimal = setResult - Math.floor(setResult);
        if (decimal > 0) {
          taxesAmount.innerHTML = setResult.toFixed(2).replace('.', ',') + ' ₽';
        } else {
          taxesAmount.innerHTML = setResult + ' ₽';
        }
        document.querySelector('[data-menu="taxes"]').appendChild(taxesAmount)
      }
    }
    return null;
  }
}

const mapStateToProps = state => ({taxes: state.paymentDocument});

const mapDispatchToProps = dispatch => {
  return {fetchData: (url, types) => dispatch(counterAction(url, types))};
}

export default connect(mapStateToProps, mapDispatchToProps)(CounterTaxes);